import $ from 'jquery';
import Swiper, { Navigation } from 'swiper';
//import vars from '!!jdi-sass-vars-to-js-loader!../../../sass/template-parts/blocks/_testimonials-slider.scss';

function initTestimonialsSlider() {
  $(function () {
    if ($('.slider-block').length <= 0) {
      return;
    }

    //customizeSliderStyles();
    initSwiperJS();
  });
}

function initSwiperJS() {
  $('.testimonials-slider').each(function(){
    let slider = $(this).find('.slider-block');
    
    let swiperTouchStartX;
  
    let swiper = new Swiper(slider.get(0), {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      pagination: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        // when window width is >= 320px
        576: {
          slidesPerView: 2,
          spaceBetween: 40
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      }
    });
  });
}

export { initTestimonialsSlider };
